import { buildWhatsAppUrl } from "@/config/contact";
import { Sparkles, X } from "lucide-react";
import { useState } from "react";

const FloatingWhatsApp = () => {
  const [isExpanded, setIsExpanded] = useState(false);
  const floatingWhatsAppUrl = buildWhatsAppUrl(
    "Ola! Preciso de ajuda com uma reserva no Melhores Retiros."
  );

  return (
    <div className="fixed bottom-5 right-5 z-40 md:bottom-8 md:right-8">
      {isExpanded && (
        <div
          id="floating-whatsapp-panel"
          className="absolute bottom-[5.8rem] right-0 w-[min(22rem,calc(100vw-2rem))] overflow-hidden rounded-[28px] border border-[#215834]/10 bg-white shadow-[0_20px_60px_rgba(19,44,33,0.22)] animate-in slide-in-from-bottom-3 fade-in-0 duration-300"
        >
          <div className="bg-gradient-to-br from-[#215834] via-[#215834] to-[#2E6F46] p-5 text-white">
            <div className="mb-3 flex items-start justify-between gap-3">
              <div className="flex items-center gap-3">
                <div className="flex h-12 w-12 items-center justify-center rounded-2xl bg-[#25D366] ring-1 ring-white/20">
                  <img src="/images/WhatsApp.svg" alt="" className="h-6 w-6" aria-hidden="true" />
                </div>
                <div>
                  <h4 className="font-fraunces text-lg font-semibold">Melhores Retiros</h4>
                  <p className="text-sm text-white/75 font-author">Suporte comercial e operacional</p>
                </div>
              </div>
              <button
                onClick={() => setIsExpanded(false)}
                className="inline-flex h-11 w-11 items-center justify-center rounded-full bg-white/10 text-white transition-colors hover:bg-white/20"
                aria-label="Fechar painel do WhatsApp"
              >
                <X className="h-4 w-4" />
              </button>
            </div>

            <div className="inline-flex items-center gap-2 rounded-full bg-white/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-white/85">
              <Sparkles className="h-3.5 w-3.5" />
              Atendimento rápido
            </div>
          </div>

          <div className="space-y-4 p-5">
            <p className="font-author text-sm leading-6 text-[#215834]/82">
              Tire dúvidas sobre reservas, disponibilidade, políticas e indicações
              de retiros sem sair da página.
            </p>

            <a
              href={floatingWhatsAppUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-12 w-full items-center justify-center gap-2 rounded-2xl bg-[#25D366] px-4 py-3 font-semibold text-white transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg"
            >
              <img src="/images/WhatsApp.svg" alt="" className="h-5 w-5" aria-hidden="true" />
              Iniciar conversa
            </a>

            <button
              type="button"
              onClick={() => setIsExpanded(false)}
              className="inline-flex min-h-11 w-full items-center justify-center rounded-2xl border border-[#215834]/10 px-4 py-3 font-semibold text-[#215834] transition-colors duration-300 hover:bg-[#F3F7F4]"
            >
              Continuar navegando
            </button>
          </div>
        </div>
      )}

      <div className="relative">
        <button
          type="button"
          onClick={() => setIsExpanded(!isExpanded)}
          className="flex h-14 w-14 items-center justify-center rounded-full border-0 bg-[#25D366] p-0 shadow-[0_18px_35px_rgba(24,96,54,0.32)] transition-transform duration-300 hover:scale-[1.06] sm:h-16 sm:w-16"
          aria-expanded={isExpanded}
          aria-controls="floating-whatsapp-panel"
          aria-label={isExpanded ? "Fechar atendimento do WhatsApp" : "Abrir atendimento do WhatsApp"}
        >
          <img src="/images/WhatsApp.svg" alt="" className="whatsapp-float-pulse h-7 w-7 sm:h-8 sm:w-8" aria-hidden="true" />
          <span className="sr-only">Falar no WhatsApp</span>
        </button>
      </div>
    </div>
  );
};

export default FloatingWhatsApp;
